<template>
  <div></div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: {
    resultName: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState('auth', ['me']),
    ...mapState('system', ['routerStatusRedirect']),
  },
  async created() {
    if (!this.me.kyc.mobileVerificationIsDone) {
      const path = '/kyc/verify-id/confirm'
      if (
        [path, '/kyc/verify-id'].includes(this.$route.path) === false &&
        this.routerStatusRedirect
      ) {
        this.$router.replace(path)
      }
      return
    }

    this.$emit('emitNext', {
      name: this.resultName,
      result: true,
    })
  },
}
</script>
